import { useQuery } from '@apollo/client';
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import GET_CURRENT_TENANT from 'api/queries/GET_CURRENT_TENANT';
import Button from 'layout/atoms/Button/Button';
import Input from 'layout/atoms/Input/Input';
import InputLabel from 'layout/atoms/InputLabel';
import Label from 'layout/atoms/Label';
import Modal from 'layout/atoms/Modal/Modal';
import { closeModal, selectModalByName } from 'store/layoutSlice';
import { addElement, selectElementById, updateElement } from 'store/parameters/elementsSlice';
function ElementEditor({ create = false }) {
    var _a, _b, _c;
    const dispatch = useDispatch();
    const elementId = (_a = useSelector(selectModalByName(create ? 'elementCreator' : 'elementEditor'))) === null || _a === void 0 ? void 0 : _a.id;
    const elementDetails = useSelector((state) => selectElementById(state, elementId || '')) || null;
    const { t } = useTranslation(['specification', 'common']);
    const { data: tenant } = useQuery(GET_CURRENT_TENANT);
    const tenantId = (_c = (_b = tenant === null || tenant === void 0 ? void 0 : tenant.me) === null || _b === void 0 ? void 0 : _b.currentTenant) === null || _c === void 0 ? void 0 : _c.id;
    const [formValues, setFormValues] = useState({
        name: '',
    });
    useEffect(() => {
        if (!create && elementDetails) {
            setFormValues({
                name: elementDetails.name,
            });
        }
    }, [create, elementDetails, elementId]);
    const handleFormChange = ({ target: { name, value }, }) => {
        setFormValues((values) => (Object.assign(Object.assign({}, values), { [name]: value })));
    };
    const handleCancel = () => {
        dispatch(closeModal({ name: create ? 'elementCreator' : 'elementEditor' }));
    };
    const handleConfirm = () => {
        if (create) {
            dispatch(addElement({ tenantId, name: formValues.name }));
        }
        else {
            dispatch(updateElement({ elementId: elementDetails.id, name: formValues.name }));
        }
        dispatch(closeModal({ name: create ? 'elementCreator' : 'elementEditor' }));
    };
    return (React.createElement(Modal, { name: create ? 'elementCreator' : 'elementEditor', size: "s", header: React.createElement(Label, { weight: "strong" }, create ? t('add_element') : t('edit_element')), footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { theme: "ghost", onClick: handleCancel }, t('common:cancel')),
            React.createElement(Button, { color: "primary", onClick: handleConfirm }, t('common:save'))), onClose: handleCancel },
        React.createElement(InputLabel, { text: t('common:name') }),
        React.createElement(Input, { value: formValues === null || formValues === void 0 ? void 0 : formValues.name, onChange: handleFormChange, name: "name", autoFocus: true })));
}
export default memo(ElementEditor);
